module dg.modules.users {

    angular.module('dg.modules.users')
        .config(($stateProvider: ng.ui.IStateProvider, $locationProvider: ng.ILocationProvider) => {

            dg.uiRouter.StateProviderBuilderService.configure($stateProvider)
                .listState('users', 'users',
                'user/list', {
                    options: () => <dg.actions.IQueryInvokerOptions>{
                        compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                            <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions()
                        ]
                    }
                })
                .listState('roles', 'roles',
                'role/list', {
                    options: () => <dg.actions.IQueryInvokerOptions>{
                        compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                            <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions()
                        ]
                    }
                });


            //$stateProvider
                //.state('app.newUser', {
                //    url: 'users/new-user',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-model.html',
                //    controller: 'DynamicActionController',
                //    resolve: {
                //        data: [(): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                apiUrl: '',
                //                actionLink: {
                //                    href: '/user/new-user'
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.users', {
                //    url: 'users',
                //    templateUrl: '/digmo/src/actions/list-query/default-list-query-view.html',
                //    resolve: {
                //        query: (actionService: dg.actions.ActionService) => {
                //            return actionService.getAction('/user/users');
                //        },
                //        options: () => {
                //            return {
                //                listOptions: dg.lists.ListOptionsService.getGridOptions()
                //            };
                //        }
                //    }
                //})
                //.state('app.roles', {
                //    url: 'roles',
                //    templateUrl: '/digmo/src/actions/list-query/default-list-query-view.html',
                //    resolve: {
                //        query: (actionService: dg.actions.ActionService) => {
                //            return actionService.getAction('/role/roles');
                //        },
                //        options: () => {
                //            return {
                //                listOptions: dg.lists.ListOptionsService.getGridOptions()
                //            };
                //        }
                //    }
                //});
            //.state('app.userProfile', {
            //    url: 'user/profile',
            //    templateUrl: '/digmo/src/components/metadata/dynamic-model.html',
            //    controller: 'DynamicActionController',
            //    resolve: {
            //        data: ['$rootScope', ($rootScope: fdm.IAppRootScopeService): dgMetadata.DynamicActionControllerData => {
            //            //TODO: return a promisse which will be resolved when current user is retriever - this will oreven page refresh exception
            //            return {
            //                actionLink: {
            //                    href: '/user/' + $rootScope.currentUser.aggregateId + '/update-user-profile'
            //                }
            //            }
            //        }]
            //    }
            //});
        });

}